import React from 'react';
import { MenuItem } from '../menu';
/**
 * Компонент `<DropdownItem />` — используется для создания элементов внутри `<Dropdown />.`
 */
export const DropdownItem = ({
  iconLeft = 'check',
  ...props
}) => (/*#__PURE__*/React.createElement(MenuItem, {
  iconLeft: iconLeft,
  ...props
}));